module.exports = __webpack_public_path__ + "img/staria-van.0f597d73.png";